module.exports = __webpack_public_path__ + "img/illustrate05.1c0c1f8d.png";